// Hakina Safety brand tokens — "Poppy Field" (Monet) palette over a teal foundation.
export const colors = {
  // Primary brand (lead)
  teal: "#25A1B0",
  tealHover: "#0E7C8B",
  tealTint: "#E6F5F7",

  // Surfaces & background
  white: "#FFFFFF",
  cream: "#F4F1E9",
  page: "#F7F9FA",

  // Secondary accent — Monet sage green
  sage: "#7E9B76",
  sageDeep: "#5E7757",

  // Accent pop — Monet poppy (use sparingly)
  poppy: "#D9482B",
  poppyTint: "#FBE9E4",

  // Text
  textPrimary: "#1F2937",
  textSecondary: "#6B7280",

  // Borders
  border: "#E5E0D5",

  // Status badges
  pendingBg: "#FBEEDA",
  pendingText: "#8A5106",
  resolvedBg: "#D7F0EC",
  resolvedText: "#0F6E56",
  criticalBg: "#FCEBEB",
  criticalText: "#A32D2D",
};
